import { FlowActionTypes } from '../store/flow/action-types';
import { getStepConfig } from '../views/getStepConfig';
export const getStepCompletionActionType = stepKey => {
  const stepConfig = getStepConfig(stepKey);

  if (stepConfig && stepConfig.stepCompletedAction) {
    return stepConfig.stepCompletedAction;
  }

  return FlowActionTypes.StepCompleted;
};
export const isOutdatedStepCompletedAction = (action, currentStep) => {
  return action.type === FlowActionTypes.StepCompleted && action.stepKey !== currentStep;
};
export const shouldGoNextStep = (action, currentStep) => {
  return action.type === getStepCompletionActionType(currentStep);
};